<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/compare/shared/product-compare-status/product-compare-status.component.ts
-->
<ng-template #anchor></ng-template>
